module.exports = __webpack_public_path__ + "img/9-2.35245649.jpg";